const getLangName = (label, lang) => {
  if (lang === "pl") {
    switch (label) {
      case "en":
        return "Angielski"
      case "pl":
        return "Polski"
      default:
        return ""
    }
  } else {
    switch (label) {
      case "en":
        return "English"
      case "pl":
        return "Polish"
      default:
        return ""
    }
  }
}

export default getLangName
